// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import TaifContract from '@/assets/img/TaifContract.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUC150', qty: o.iuc150 ?? '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier     ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation',          group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const TAIF_PROFILE_CONFIG = {

//   // ── Taif On-Street Profile ──────────────────────────────────────────
//   taif_on_street_profile: {
//     profileKey:     'taif_on_street_profile',
//     violationKey:   'taif_on_street_violations',
//     parkingTariffKey: 'taif_on_street_parking_tariff',
//     membershipKey:  'taif_on_street_membership',
//     assetsKey:      'taif_on_street_assets',
//     pageType:       'on_street',

//     profileFallback: {
//       table_key: 'taif_on_street_profile',
//       title: 'Taif On Street - Profile',
//       data: {
//         total_bays:        { label: 'Total On-Street Parking Bays', value: '2,666' },
//         contract_term:     { value: '15 years' },
//         contract_period:   { start_date: '07.07.2018', end_date: '02.09.2033' },
//         parking_violation: { value: 'Parking and Violation charges are as per below table' },
//         membership_tariff: { value: 'Membership and Enforcement tariff excluding 15% VAT' },
//       },
//     },

//     violationFallback: {
//       table_key: 'taif_on_street_violations',
//       title: 'Taif On Street Violation Summary (Excluding Vat)',
//       data: {
//         rows: [
//           { city_code: 'TAF', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                     ticket_charges: '200',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',      ticket_charges: '100',        tow_charges: '0',       clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                      ticket_charges: '100',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                              ticket_charges: '100',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                           ticket_charges: '300',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                 ticket_charges: '300',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                     ticket_charges: '900',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                               ticket_charges: '500',        tow_charges: '250',     clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                            ticket_charges: '0',          tow_charges: '250/1250', clamp_charges: '0' },
//           { city_code: 'TAF', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                        ticket_charges: '20/50 per day', tow_charges: '0',   clamp_charges: '0' },
//         ],
//       },
//     },

//     parkingTariffFallback: {
//       table_key: 'taif_on_street_parking_tariff',
//       title: 'On Street Parking Tariff (Excluding Vat)',
//       data: {
//         rows: [
//           { product: 'Taif On Street', vehicle_type: 'Car', tariff: '02 SAR', timing: '08:00 AM - 12:00 PM', working_day: 'Friday Off', rowSpan: 2, },
//           { product: '',               vehicle_type: 'Bus', tariff: '10 SAR', timing: '04:00 PM - 10:00 PM', working_day: '' },
//         ],
//       },
//     },

//     membershipFallback: {
//       table_key: 'taif_on_street_membership',
//       title: 'Membership Price Excluding Vat',
//       data: {
//         rows: [
//           { product: 'One Month- Taxi',    price: 'SAR 150' },
//           { product: 'One Month- Private', price: 'SAR 350' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'taif_on_street_assets',
//       title: 'Taif On-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '2', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '2', right: '1', left: '1',
//           pnds: '106', tpalTx: '53', tpalV2: '53',
//           poundCahier: '-', driverDevice: '-',
//           enfDevice: '53', oukitel: '8', doogee: '45',
//           validation: '-', printer: '64', pr3: '20', sewoo: '8', bixolon: '36',
//           towTruck: '9', clampVehicle: '3', supportVehicle: '1',
//         }),
//       },
//     },
//   },

//   // ── Taif Off-Street Profile ─────────────────────────────────────────
//   taif_off_street_profile: {
//     profileKey:    'taif_off_street_profile',
//     membershipKey: 'taif_off_street_membership',
//     assetsKey:     'taif_off_street_assets',
//     pageType:      'off_street',

//     profileFallback: {
//       table_key: 'taif_off_street_profile',
//       title: 'Taif Off-Street Profile',
//       data: {
//         total_bays:        { label: 'Total Off Street Car Park Bays', value: '241' },
//         contract_term:     { value: '15 years' },
//         contract_period:   { start_date: '07.07.2018', end_date: '02.09.2033' },
//         rate_per_hour:     { value: 'SAR 2.00 excluding 15%VAT' },
//         membership_tariff: { value: 'Membership Rates excluding 15% VAT' },
//       },
//     },

//     membershipFallback: {
//       table_key: 'taif_off_street_membership',
//       title: 'Membership Price Excluding Vat',
//       data: {
//         rows: [
//           { product: 'One Month- Taxi',    price: 'SAR 150' },
//           { product: 'One Month- Private', price: 'SAR 350' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'taif_off_street_assets',
//       title: 'Taif Off-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '-',
//           apms: '1', apmEts70: '1',
//           pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '-', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '-', pnds: '-', poundCahier: '-',
//           driverDevice: '-', enfDevice: '-', validation: '-',
//           printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const TaifProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = TAIF_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef   = useRef(false);
//   const saveRef         = useRef(null);
//   const [isSaving, setIsSaving]                       = useState(false);
//   const [profileTable, setProfileTable]               = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable]                 = useState(cfg.assetsFallback);
//   const [violationTable, setViolationTable]           = useState(cfg.violationFallback || null);
//   const [parkingTariffTable, setParkingTariffTable]   = useState(cfg.parkingTariffFallback || null);
//   const [membershipTable, setMembershipTable]         = useState(cfg.membershipFallback || null);
//   const { enqueue } = useApiQueue();
//   // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef       = useRef(null);
//   const assetsRef        = useRef(null);
//   const violationRef     = useRef(null);
//   const parkingTariffRef = useRef(null);
//   const membershipRef    = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current       = profileTable;      }, [profileTable]);
//   useEffect(() => { assetsRef.current        = assetsTable;       }, [assetsTable]);
//   useEffect(() => { violationRef.current     = violationTable;    }, [violationTable]);
//   useEffect(() => { parkingTariffRef.current = parkingTariffTable;}, [parkingTariffTable]);
//   useEffect(() => { membershipRef.current    = membershipTable;   }, [membershipTable]);
//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       if (cfg.violationKey)      setViolationTable(find(cfg.violationKey, cfg.violationFallback));
//       if (cfg.parkingTariffKey)  setParkingTariffTable(find(cfg.parkingTariffKey, cfg.parkingTariffFallback));
//       if (cfg.membershipKey)     setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//    // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       if (violationRef.current) {
//         tables.push({ 
//           table_key: violationRef.current.table_key, 
//           title: violationRef.current.title, 
//           data: violationRef.current.data 
//         });
//       }
//       if (parkingTariffRef.current) {
//         tables.push({ 
//           table_key: parkingTariffRef.current.table_key, 
//           title: parkingTariffRef.current.title, 
//           data: parkingTariffRef.current.data 
//         });
//       }
//       if (membershipRef.current) {
//         tables.push({ 
//           table_key: membershipRef.current.table_key, 
//           title: membershipRef.current.title, 
//           data: membershipRef.current.data 
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1, 
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleViolationCell = (rIdx, key, value) => {
//     setViolationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleParkingTariffCell = (rIdx, key, value) => {
//     setParkingTariffTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleMembershipCell = (rIdx, key, value) => {
//     setMembershipTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Derived ───────────────────────────────────────────────────────────
//   const pd         = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType   = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
// <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />          </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <>
//           {/* Activities icons row */}
          

//           <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
            
//             {/* ── LEFT ── */}
//             <div className="flex-1 pr-4">
//              <div className="flex flex-col">
//                <div className="mb-4">
//             <p className="text-[16px] font-bold mb-3">Activities:</p>
//             <div className="flex gap-0 justify-start ml-16 ">
//               {['On Street', 'Car Park', 'Enforcement'].map(label => (
//                 <div key={label} className="flex flex-col items-center gap-2 ">
//                     {label === 'On Street' && <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '140px', objectFit: 'contain' }} />  }
//                     {label === 'Car Park' &&  <img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '150px', objectFit: 'contain' }} />}
//                     {label === 'Enforcement' &&  <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '140px', objectFit: 'contain' }} />}
//                   </div>
                  
                
//               ))}
//             </div>
//           </div>

//               {/* Profile info */}
//               <div className="flex items-center gap-2 mb-1 ml-2">
//                 <div className="w-10 h-8 bg-gray-100 !border border-gray-300! rounded flex items-center justify-center text-[8px] text-gray-400"><img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
//                   </strong>
//                 </span>
//               </div>
//              </div>

//               <div className="flex items-center gap-2 mb-1 ml-8">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center gap-1 whitespace-nowrap">
//                   Contract term{' '}
//                   <strong><input type="text" value={pd.contract_term?.value || ''}
//                     onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                   ; start date{' '}
//                   <strong><input
//   type="text"
//   value={pd.contract_period?.start_date || ''}
//   onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16"
// />
//   {' to '}
// <input
//   type="text"
//   value={pd.contract_period?.end_date || ''}
//   onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20"
// /></strong>
//                 </span>
//               </div>

//               <div className="flex items-center gap-2 mb-1 ml-8">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   <input type="text" value={pd.parking_violation?.value || ''}
//                     onChange={e => patchProfile('parking_violation', 'value', e.target.value)}
//                     className="outline-none bg-transparent !border-0 text-[12px] w-80 font-semibold" />
//                 </span>
//               </div>

//               <div className="flex items-center gap-2 mb-1 ml-8">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>

//               <div className="flex items-center gap-2 mb-4 ml-8">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                 <span className="text-[12px]">
//   {pd.membership_tariff?.value?.replace(' excluding 15% VAT', '')}
//   <strong> excluding 15% VAT</strong>
// </span>
//                 </span>
//               </div>

//               {/* ── Tables row ── */}
//               <div className="flex flex-col xl:flex-row gap-4">

//                 {/* Violation Summary Table */}
//                 {violationTable && (
//                   <div className="">
//                     <table className="!border-collapse text-[8px]">
//                       <thead>
//                         <tr>
//                           <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
//                             {violationTable.title}
//                           </th>
//                         </tr>
//                         <tr className="bg-white">
//                           {['City Code', 'Violation Code', 'Violation Name En', 'Ticket Charges', 'Tow Charges', 'Clamp Charges'].map(h => (
//                             <th key={h} className="!border !border-black px-1.5 py-1 font-bold text-center"
//                               style={{ minWidth: h === 'Violation Name En' ? '180px' : '55px' }}>
//                               {h}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {violationTable.data.rows.map((row, rIdx) => (
//                           <tr key={rIdx} className={'bg-white' }>
//                             {[
//                               { key: 'city_code', w: '45px' },
//                               { key: 'violation_code', w: '50px' },
//                               { key: 'violation_name', isLong: true  },
//                               { key: 'ticket_charges', w: '60px' },
//                               { key: 'tow_charges', w: '60px' },
//                               { key: 'clamp_charges', w: '60px' },
//                             ].map(({ key, w,isLong }) => (
//                               <td className="!border !border-black px-1 py-0.5 align-top">
//   {isLong ? (
//     <textarea
//       value={row[key] || ''}
//       onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//       rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] resize-none overflow-hidden w-full "
//       style={{ minWidth: '260px' }}
//       onInput={(e) => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//   ) : (
//     <input
//       type="text"
//       value={row[key] || ''}
//       onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//       className="!border-0 bg-transparent outline-none text-[8px] text-center"
//       style={{ width: w }}
//     />
//   )}
// </td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}

//                 {/* Right side — Parking Tariff + Membership */}
//                 <div className="flex flex-col gap-4">
//                   {/* Parking Tariff */}
//                   {parkingTariffTable && (
//                     <table className="!border-collapse text-[8px]">
//                       <thead>
//                         <tr>
//                           <th colSpan={5} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
//                             {parkingTariffTable.title}
//                           </th>
//                         </tr>
//                         <tr className="bg-gray-300">
//                           {['Product', 'Vehicle Type', 'Tariff', 'Timing', 'Working Day'].map(h => (
//                             <th key={h} className="!border !border-black px-2 py-1 font-bold text-center"
//                               style={{ minWidth: h === 'Timing' ? '120px' : '80px' }}>
//                               {h}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {parkingTariffTable.data.rows.map((row, rIdx) => (
//                           <tr key={rIdx} className={ 'bg-white' }>
//                              {[
//   { key: 'product', w: '90px', isRowSpan: true },
//   { key: 'vehicle_type', w: '60px' },
//   { key: 'tariff', w: '55px' },
//   { key: 'timing', w: '120px' },
//   { key: 'working_day', w: '70px', isRowSpan: true },
// ].map(({ key, w, isRowSpan }) => {

//   // 🔥 RowSpan columns (product + working_day)
//   if (isRowSpan) {
//     if (!row.rowSpan) return null;

//     return (
//       <td
//         key={key}
//         rowSpan={row.rowSpan}
//         className="!border !border-black px-1.5 py-1 text-center align-middle"
//       >
//         <input
//           type="text"
//           value={row[key] || ''}
//           onChange={e => handleParkingTariffCell(rIdx, key, e.target.value)}
//           // className="!border-0 bg-transparent outline-none text-[8px] text-center w-full"
//           style={{ width: w }}
// className="!border-0 bg-transparent outline-none text-[8px] text-center"
//         />
//       </td>
//     );
//   }

//   // Normal cells
//   return (
//     <td key={key} className="!border !border-black px-1.5 py-1 text-center">
//       <input
//         type="text"
//         value={row[key] || ''}
//         onChange={e => handleParkingTariffCell(rIdx, key, e.target.value)}
//         className="!border-0 bg-transparent outline-none text-[8px] text-center"
//         style={{ width: w }}
//       />
//     </td>
//   );
// })}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   )}

//                   {/* Membership */}
//                   {membershipTable && (
//                     <table className="!border-collapse text-[8px]">
//                       <thead>
//                         <tr>
//                           <th className="!border !border-black px-3 py-2 bg-gray-300 text-center font-bold" style={{ minWidth: '140px' }}>Product</th>
//                           <th className="!border !border-black px-3 py-2 bg-gray-300 text-center font-bold" style={{ minWidth: '140px' }}>
//                             {membershipTable.title}
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {membershipTable.data.rows.map((row, rIdx) => (
//                           <tr key={rIdx} className={ 'bg-white'  }>
//                             <td className="!border !border-black px-3 py-1.5">
//                               <input type="text" value={row.product || ''} onChange={e => handleMembershipCell(rIdx, 'product', e.target.value)}
//                                 className="!border-0 bg-transparent outline-none text-[8px] w-full" />
//                             </td>
//                             <td className="!border !border-black px-3 py-1.5 text-center">
//                               <input type="text" value={row.price || ''} onChange={e => handleMembershipCell(rIdx, 'price', e.target.value)}
//                                 className="!border-0 bg-transparent outline-none text-[8px] text-center w-full" />
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* ── RIGHT — Assets ── */}
//             <AssetsPanel
//               assetsTable={assetsTable}
//               flatAssets={flatAssets}
//               onSubCount={handleAssetSubCount}
//               onTotalCount={handleAssetTotalCount}
//             />
//           </div>
//         </>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//           {/* ── LEFT ── */}
//           <div className="flex-1 pr-4">

//             {/* Car Park icon + info */}
//             <div className="flex items-start gap-0 mb-4">
//               <div className="flex flex-col items-center  rounded   w-20 flex-shrink-0">
//                <img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
//               </div>
//               <div className="flex flex-col gap-1">
//                 <div className="flex items-center gap-2">
                 
//                   <span className="text-[12px]">
//                     {pd.total_bays?.label}{' '}
//                     <strong>
//                       <input type="text" value={pd.total_bays?.value || ''}
//                         onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-15" />
//                     </strong>
//                   </span>
//                 </div>

//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Contract term{' '}
//                     <strong><input type="text" value={pd.contract_term?.value || ''}
//                       onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                     ; start date{' '}
//                     <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                       onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//                     {' to '}
//                     <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                   </span>
//                 </div>

//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Rate per Hour{' '}
//                     <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
//                   </span>
//                 </div>

//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>

//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border border-blue-600! flex-shrink-0" />
//                   <span className="text-[12px]">
//                     <input type="text" value={pd.membership_tariff?.value || ''}
//                       onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
//                       className="outline-none bg-transparent !border-0 text-[12px] w-72" />
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Membership Table */}
//             {membershipTable && (
//               <div className="ml-4">
//                 <table className="!border-collapse text-[10px]">
//                   <thead>
//                     <tr>
//                       <th className="!border !border-black px-6 py-2.5 bg-gray-300 text-center font-bold" style={{ minWidth: '200px' }}>Product</th>
//                       <th className="!border !border-black px-6 py-2.5 bg-gray-300 text-center font-bold" style={{ minWidth: '180px' }}>
//                         {membershipTable.title}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {membershipTable.data.rows.map((row, rIdx) => (
//                       <tr key={rIdx} className={ 'bg-white' }>
//                         <td className="!border !border-black px-4 py-2">
//                           <input type="text" value={row.product || ''} onChange={e => handleMembershipCell(rIdx, 'product', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[10px] w-full" />
//                         </td>
//                         <td className="!border !border-black px-4 py-2 text-center">
//                           <input type="text" value={row.price || ''} onChange={e => handleMembershipCell(rIdx, 'price', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[10px] text-center w-full" />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* ── RIGHT — Assets ── */}
//           <AssetsPanel
//             assetsTable={assetsTable}
//             flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount}
//             onTotalCount={handleAssetTotalCount}
//           />
//         </div>
//       )}

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default TaifProfile;















import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import TaifContract from '@/assets/img/TaifContract.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUC150', qty: o.iuc150 ?? '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier     ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
    { group_name: 'Driver Device',       group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation',          group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const TAIF_PROFILE_CONFIG = {

  // ── Taif On-Street Profile ──────────────────────────────────────────
  taif_on_street_profile: {
    profileKey:     'taif_on_street_profile',
    violationKey:   'taif_on_street_violations',
    parkingTariffKey: 'taif_on_street_parking_tariff',
    membershipKey:  'taif_on_street_membership',
    assetsKey:      'taif_on_street_assets',
    pageType:       'on_street',

    profileFallback: {
      table_key: 'taif_on_street_profile',
      title: 'Taif On Street - Profile',
      data: {
        total_bays:        { label: 'Total On-Street Parking Bays', value: '2,666' },
        contract_term:     { value: '15 years' },
        contract_period:   { start_date: '07.07.2018', end_date: '02.09.2033' },
        parking_violation: { value: 'Parking and Violation charges are as per below table' },
        membership_tariff: { value: 'Membership and Enforcement tariff excluding 15% VAT' },
      },
    },

    violationFallback: {
      table_key: 'taif_on_street_violations',
      title: 'Taif On Street Violation Summary (Excluding Vat)',
      data: {
        rows: [
          { city_code: 'TAF', violation_code: '1',  violation_name: 'THE USE OF PARKING SPACE WITHOUT PAYING THE PARKING FEE',                     ticket_charges: '200',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '2',  violation_name: 'THE EXPIRY OF THE PAID PARKING PERIOD WITHOUT VACATING THE PARKING SPACE',      ticket_charges: '100',        tow_charges: '0',       clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '3',  violation_name: 'EXCEEDING THE MAXIMUM TIME ALLOWED FOR THE PARKING SPACE',                      ticket_charges: '100',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '4',  violation_name: 'PARKING CONTRARILY WITHIN THE PAID PARKING SPACE',                              ticket_charges: '100',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '5',  violation_name: 'PARKING IN A RESERVED PARKING SPACE',                                           ticket_charges: '300',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '6',  violation_name: 'PARKING IN A RESTRICTED SPACE',                                                 ticket_charges: '300',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '7',  violation_name: 'PLACING BARRIERS, OBSTRUCTIONS, FORGERY, OR CLOSING A PARKING SPACE WITHOUT A PERMIT', ticket_charges: '400', tow_charges: '250',   clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '8',  violation_name: 'PARKING IN THE EMERGENCY DESIGNATED AREAS',                                     ticket_charges: '900',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '9',  violation_name: 'PARKING AT THE ENTRANCES AND EXITS OF BUILDINGS',                               ticket_charges: '500',        tow_charges: '250',     clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '10', violation_name: 'TOW CHARGES (Light & Heavy Vehicle)',                                            ticket_charges: '0',          tow_charges: '250/1250', clamp_charges: '0' },
          { city_code: 'TAF', violation_code: '11', violation_name: 'STORAGE CHARGES (Light & Heavy Vehicle)',                                        ticket_charges: '20/50 per day', tow_charges: '0',   clamp_charges: '0' },
        ],
      },
    },

    parkingTariffFallback: {
      table_key: 'taif_on_street_parking_tariff',
      title: 'On Street Parking Tariff (Excluding Vat)',
      data: {
        rows: [
          { product: 'Taif On Street', vehicle_type: 'Car', tariff: '02 SAR', timing: '08:00 AM - 12:00 PM', working_day: 'Friday Off', rowSpan: 2, },
          { product: '',               vehicle_type: 'Bus', tariff: '10 SAR', timing: '04:00 PM - 10:00 PM', working_day: '' },
        ],
      },
    },

    membershipFallback: {
      table_key: 'taif_on_street_membership',
      title: 'Membership Price Excluding Vat',
      data: {
        rows: [
          { product: 'One Month- Taxi',    price: 'SAR 150' },
          { product: 'One Month- Private', price: 'SAR 350' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'taif_on_street_assets',
      title: 'Taif On-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '1', evG10064: '1',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '2', ipBarrier: '-', anprCamera: '-',
          slidingGate: '2', right: '1', left: '1',
          pnds: '106', tpalTx: '53', tpalV2: '53',
          poundCahier: '-', driverDevice: '-',
          enfDevice: '53', oukitel: '8', doogee: '45',
          validation: '-', printer: '64', pr3: '20', sewoo: '8', bixolon: '36',
          towTruck: '9', clampVehicle: '3', supportVehicle: '1',
        }),
      },
    },
  },

  // ── Taif Off-Street Profile ─────────────────────────────────────────
  taif_off_street_profile: {
    profileKey:    'taif_off_street_profile',
    membershipKey: 'taif_off_street_membership',
    assetsKey:     'taif_off_street_assets',
    pageType:      'off_street',

    profileFallback: {
      table_key: 'taif_off_street_profile',
      title: 'Taif Off-Street Profile',
      data: {
        total_bays:        { label: 'Total Off Street Car Park Bays', value: '241' },
        contract_term:     { value: '15 years' },
        contract_period:   { start_date: '07.07.2018', end_date: '02.09.2033' },
        rate_per_hour:     { value: 'SAR 2.00 excluding 15%VAT' },
        membership_tariff: { value: 'Membership Rates excluding 15% VAT' },
      },
    },

    membershipFallback: {
      table_key: 'taif_off_street_membership',
      title: 'Membership Price Excluding Vat',
      data: {
        rows: [
          { product: 'One Month- Taxi',    price: 'SAR 150' },
          { product: 'One Month- Private', price: 'SAR 350' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'taif_off_street_assets',
      title: 'Taif Off-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-',
          apms: '1', apmEts70: '1',
          pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '-', ipBarrier: '-', anprCamera: '-',
          slidingGate: '-', pnds: '-', poundCahier: '-',
          driverDevice: '-', enfDevice: '-', validation: '-',
          printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const TaifProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = TAIF_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef   = useRef(false);
  const saveRef         = useRef(null);
  const [isSaving, setIsSaving]                       = useState(false);
  const [profileTable, setProfileTable]               = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable]                 = useState(cfg.assetsFallback);
  const [violationTable, setViolationTable]           = useState(cfg.violationFallback || null);
  const [parkingTariffTable, setParkingTariffTable]   = useState(cfg.parkingTariffFallback || null);
  const [membershipTable, setMembershipTable]         = useState(cfg.membershipFallback || null);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable.data.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef       = useRef(null);
  const assetsRef        = useRef(null);
  const violationRef     = useRef(null);
  const parkingTariffRef = useRef(null);
  const membershipRef    = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current       = profileTable;      }, [profileTable]);
  useEffect(() => { assetsRef.current        = assetsTable;       }, [assetsTable]);
  useEffect(() => { violationRef.current     = violationTable;    }, [violationTable]);
  useEffect(() => { parkingTariffRef.current = parkingTariffTable;}, [parkingTariffTable]);
  useEffect(() => { membershipRef.current    = membershipTable;   }, [membershipTable]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0020013",
        year: year,
        month: month,
        device_onstreet: "TAF",
        type: "on_street"
      } : {
        contract: "0020014",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        if (cfg.violationKey)      setViolationTable(find(cfg.violationKey, cfg.violationFallback));
        if (cfg.parkingTariffKey)  setParkingTariffTable(find(cfg.parkingTariffKey, cfg.parkingTariffFallback));
        if (cfg.membershipKey)     setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      if (violationRef.current) {
        tables.push({ 
          table_key: violationRef.current.table_key, 
          title: violationRef.current.title, 
          data: violationRef.current.data 
        });
      }
      if (parkingTariffRef.current) {
        tables.push({ 
          table_key: parkingTariffRef.current.table_key, 
          title: parkingTariffRef.current.title, 
          data: parkingTariffRef.current.data 
        });
      }
      if (membershipRef.current) {
        tables.push({ 
          table_key: membershipRef.current.table_key, 
          title: membershipRef.current.title, 
          data: membershipRef.current.data 
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1, 
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleViolationCell = (rIdx, key, value) => {
    setViolationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleParkingTariffCell = (rIdx, key, value) => {
    setParkingTariffTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleMembershipCell = (rIdx, key, value) => {
    setMembershipTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Derived ───────────────────────────────────────────────────────────
  const pd         = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType   = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-1 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={TaifContract} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <>
          <div className="flex flex-row gap-0 !border-2 !border-black p-3">
            
            {/* ── LEFT ── */}
            <div className="flex-1 pr-4" style={{zoom:"90%"}}>
              <div className="flex flex-col">
                <div className="mb-4">
                  <p className="text-[16px] font-bold mb-3">Activities:</p>
                  <div className="flex gap-0 justify-start ml-16 ">
                    {['On Street', 'Car Park', 'Enforcement'].map(label => (
                      <div key={label} className="flex flex-col items-center gap-2 ">
                        {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '140px', objectFit: 'contain' }} />}
                        {label === 'Car Park' && <img src={CarPark} alt="Car Park" style={{ height: '150px', objectFit: 'contain' }} />}
                        {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '140px', objectFit: 'contain' }} />}
                      </div>
                    ))}
                  </div>
                </div>

                {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
                <div className="flex items-center gap-2 mb-1 ml-2">
                  <div className="w-10 h-8 bg-gray-100 !border border-gray-300! rounded flex items-center justify-center text-[8px] text-gray-400">
                    <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
                  </div>
                  <span className="text-[12px]">
                    {pd.total_bays?.label}{' '}
                    <strong>
                      <input 
                        type="text" 
                        value={effectiveTotalBays}
                        readOnly 
                        disabled
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
                      />
                    </strong>
                  </span>
                </div>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 mb-1 ml-8">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center gap-1 whitespace-nowrap">
                  Contract term{' '}
                  <strong><input type="text" value={pd.contract_term?.value || ''}
                    onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
                  ; start date{' '}
                  <strong><input type="text" value={pd.contract_period?.start_date || ''}
                    onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
                  {' to '}
                  <strong><input type="text" value={pd.contract_period?.end_date || ''}
                    onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" /></strong>
                </span>
              </div>

              {/* Parking Violation Note - Editable */}
              <div className="flex items-center gap-2 mb-1 ml-8">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  <input type="text" value={pd.parking_violation?.value || ''}
                    onChange={e => patchProfile('parking_violation', 'value', e.target.value)}
                    className="outline-none bg-transparent !border-0 text-[12px] w-80 font-semibold" />
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 mb-1 ml-8">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>

              {/* Membership Tariff - Editable */}
              <div className="flex items-center gap-2 mb-4 ml-8">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  <span className="text-[12px]">
                    {pd.membership_tariff?.value?.replace(' excluding 15% VAT', '')}
                    <strong> excluding 15% VAT</strong>
                  </span>
                </span>
              </div>

              {/* ── Tables row ── */}
              <div className="flex flex-row gap-4">

                {/* Violation Summary Table - Editable */}
                {violationTable && (
                  <div className="">
                    <table className="!border-collapse text-[8px]">
                      <thead>
                        <tr>
                          <th colSpan={6} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
                            {violationTable.title}
                          </th>
                        </tr>
                        <tr className="bg-white">
                          {['City Code', 'Violation Code', 'Violation Name En', 'Ticket Charges', 'Tow Charges', 'Clamp Charges'].map(h => (
                            <th key={h} className="!border !border-black px-1.5 py-1 font-bold text-center"
                              style={{ minWidth: h === 'Violation Name En' ? '180px' : '55px' }}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {violationTable.data.rows.map((row, rIdx) => (
                          <tr key={rIdx} className={'bg-white'}>
                            {[
                              { key: 'city_code', w: '45px' },
                              { key: 'violation_code', w: '50px' },
                              { key: 'violation_name', isLong: true },
                              { key: 'ticket_charges', w: '60px' },
                              { key: 'tow_charges', w: '60px' },
                              { key: 'clamp_charges', w: '60px' },
                            ].map(({ key, w, isLong }) => (
                              <td key={key} className="!border !border-black px-1 py-0.5 align-top">
                                {isLong ? (
                                  <textarea
                                    value={row[key] || ''}
                                    onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                    rows={1}
                                    className="!border-0 bg-transparent outline-none text-[8px] resize-none overflow-hidden w-full"
                                    style={{ minWidth: '260px' }}
                                    onInput={(e) => {
                                      e.target.style.height = 'auto';
                                      e.target.style.height = e.target.scrollHeight + 'px';
                                    }}
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    value={row[key] || ''}
                                    onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                    className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                    style={{ width: w }}
                                  />
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Right side — Parking Tariff + Membership */}
                <div className="flex flex-col gap-4">
                  {/* Parking Tariff - Editable */}
                  {parkingTariffTable && (
                    <table className="!border-collapse text-[8px]">
                      <thead>
                        <tr>
                          <th colSpan={5} className="!border !border-black px-2 py-1.5 bg-gray-300 text-center font-bold text-[9px]">
                            {parkingTariffTable.title}
                          </th>
                        </tr>
                        <tr className="bg-gray-300">
                          {['Product', 'Vehicle Type', 'Tariff', 'Timing', 'Working Day'].map(h => (
                            <th key={h} className="!border !border-black px-2 py-1 font-bold text-center"
                              style={{ minWidth: h === 'Timing' ? '120px' : '80px' }}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {parkingTariffTable.data.rows.map((row, rIdx) => (
                          <tr key={rIdx} className={'bg-white'}>
                            {[
                              { key: 'product', w: '90px', isRowSpan: true },
                              { key: 'vehicle_type', w: '60px' },
                              { key: 'tariff', w: '55px' },
                              { key: 'timing', w: '120px' },
                              { key: 'working_day', w: '70px', isRowSpan: true },
                            ].map(({ key, w, isRowSpan }) => {
                              if (isRowSpan) {
                                if (!row.rowSpan) return null;
                                return (
                                  <td key={key} rowSpan={row.rowSpan} className="!border !border-black px-1.5 py-1 text-center align-middle">
                                    <input
                                      type="text"
                                      value={row[key] || ''}
                                      onChange={e => handleParkingTariffCell(rIdx, key, e.target.value)}
                                      className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                      style={{ width: w }}
                                    />
                                  </td>
                                );
                              }
                              return (
                                <td key={key} className="!border !border-black px-1.5 py-1 text-center">
                                  <input
                                    type="text"
                                    value={row[key] || ''}
                                    onChange={e => handleParkingTariffCell(rIdx, key, e.target.value)}
                                    className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                    style={{ width: w }}
                                  />
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  {/* Membership - Editable */}
                  {membershipTable && (
                    <table className="!border-collapse text-[8px]">
                      <thead>
                        <tr>
                          <th className="!border !border-black px-3 py-2 bg-gray-300 text-center font-bold" style={{ minWidth: '140px' }}>Product</th>
                          <th className="!border !border-black px-3 py-2 bg-gray-300 text-center font-bold" style={{ minWidth: '140px' }}>
                            {membershipTable.title}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {membershipTable.data.rows.map((row, rIdx) => (
                          <tr key={rIdx} className={'bg-white'}>
                            <td className="!border !border-black px-3 py-1.5">
                              <input type="text" value={row.product || ''} onChange={e => handleMembershipCell(rIdx, 'product', e.target.value)}
                                className="!border-0 bg-transparent outline-none text-[8px] w-full" />
                            </td>
                            <td className="!border !border-black px-3 py-1.5 text-center">
                              <input type="text" value={row.price || ''} onChange={e => handleMembershipCell(rIdx, 'price', e.target.value)}
                                className="!border-0 bg-transparent outline-none text-[8px] text-center w-full" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            {/* ── RIGHT — Assets ── */}
            <AssetsPanel
              assetsTable={assetsTable}
              flatAssets={flatAssets}
              onSubCount={handleAssetSubCount}
              onTotalCount={handleAssetTotalCount}
            />
          </div>
        </>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">
          {/* ── LEFT ── */}
          <div className="flex-1 pr-4">

            {/* Car Park icon + info */}
            <div className="flex items-start gap-0 mb-4">
              <div className="flex flex-col items-center rounded w-20 flex-shrink-0">
                <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
              </div>
              <div className="flex flex-col gap-1">
                {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
                <div className="flex items-center gap-2">
                  <span className="text-[12px]">
                    {pd.total_bays?.label}{' '}
                    <strong>
                      <input 
                        type="text" 
                        value={effectiveTotalBays}
                        readOnly 
                        disabled
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-15 cursor-default" 
                      />
                    </strong>
                  </span>
                </div>

                {/* Contract Term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Contract term{' '}
                    <strong><input type="text" value={pd.contract_term?.value || ''}
                      onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
                    ; start date{' '}
                    <strong><input type="text" value={pd.contract_period?.start_date || ''}
                      onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
                    {' to '}
                    <strong><input type="text" value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
                  </span>
                </div>

                {/* Rate per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Rate per Hour{' '}
                    <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
                  </span>
                </div>

                {/* Assets Deployed */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>

                {/* Membership Tariff - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border border-blue-600! flex-shrink-0" />
                  <span className="text-[12px]">
                    <input type="text" value={pd.membership_tariff?.value || ''}
                      onChange={e => patchProfile('membership_tariff', 'value', e.target.value)}
                      className="outline-none bg-transparent !border-0 text-[12px] w-72" />
                  </span>
                </div>
              </div>
            </div>

            {/* Membership Table - Editable */}
            {membershipTable && (
              <div className="ml-4">
                <table className="!border-collapse text-[10px]">
                  <thead>
                    <tr>
                      <th className="!border !border-black px-6 py-2.5 bg-gray-300 text-center font-bold" style={{ minWidth: '200px' }}>Product</th>
                      <th className="!border !border-black px-6 py-2.5 bg-gray-300 text-center font-bold" style={{ minWidth: '180px' }}>
                        {membershipTable.title}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {membershipTable.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className={'bg-white'}>
                        <td className="!border !border-black px-4 py-2">
                          <input type="text" value={row.product || ''} onChange={e => handleMembershipCell(rIdx, 'product', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[10px] w-full" />
                        </td>
                        <td className="!border !border-black px-4 py-2 text-center">
                          <input type="text" value={row.price || ''} onChange={e => handleMembershipCell(rIdx, 'price', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[10px] text-center w-full" />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* ── RIGHT — Assets ── */}
          <AssetsPanel
            assetsTable={assetsTable}
            flatAssets={flatAssets}
            onSubCount={handleAssetSubCount}
            onTotalCount={handleAssetTotalCount}
          />
        </div>
      )}
    </div>
  );
};

export default TaifProfile;